import React, { useEffect } from 'react';
import { styles } from './MenuUnderlay.css';

export type MenuUnderlayProps = { onClick: () => void; isOpen: boolean };

export const MenuUnderlay = ({ onClick, isOpen }: MenuUnderlayProps) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add(styles.body);
    } else {
      document.body.classList.remove(styles.body);
    }
  });

  return <button type="button" className={styles.background({ isOpen })} onClick={() => isOpen && onClick()} />;
};
